"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var user_1 = tslib_1.__importDefault(require("../user"));
var bank_1 = tslib_1.__importDefault(require("../system/bank"));
var company_1 = tslib_1.__importDefault(require("../system/company"));
var production_1 = tslib_1.__importDefault(require("../system/production"));
var BatchResource = /** @class */ (function (_super) {
    tslib_1.__extends(BatchResource, _super);
    function BatchResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BatchResource.related = function () {
        return {
            user: user_1.default,
            bank: bank_1.default,
            company: company_1.default,
            production: production_1.default,
        };
    };
    BatchResource.endpoint = '/batches';
    BatchResource.MODEL_NAME = 'batch';
    return BatchResource;
}(base_1.default));
exports.default = BatchResource;
//# sourceMappingURL=batch.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/batch.js
// module id = P7ns
// module chunks = 0